module.exports = __webpack_public_path__ + "media/images/sports_icons/dodgeball-b53d59f56b57e5c5bc5580f89285d12f.png";